export const RESET_STATE = "@roles/RESET_STATE";
export const SET_ERROR = "@roles/SET_ERROR";

export const GET_ROLE_REQUEST = "@roles/GET_ROLE_REQUEST";
export const GET_ROLE_SUCCESS = "@roles/GET_ROLE_SUCCESS";
export const GET_ROLE_FAILURE = "@roles/GET_ROLE_FAILURE";

export const UPDATE_ROLE_REQUEST = "@roles/UPDATE_ROLE_REQUEST";
export const UPDATE_ROLE_SUCCESS = "@roles/UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAILURE = "@roles/UPDATE_ROLE_FAILURE";

export const SELECT_ROLE_REQUEST = "@roles/SELECT_ROLE_REQUEST";
export const SELECT_ROLE_SUCCESS = "@roles/SELECT_ROLE_SUCCESS";
export const SELECT_ROLE_FAILURE = "@roles/SELECT_ROLE_FAILURE";

export const CREATE_ROLE_REQUEST = "@roles/CREATE_ROLE_REQUEST";
export const CREATE_ROLE_SUCCESS = "@roles/CREATE_ROLE_SUCCESS";
export const CREATE_ROLE_FAILURE = "@roles/CREATE_ROLE_FAILURE";